export const isString = obj => Object.prototype.toString.call(obj) === "[object String]"
export const splitOn = separator => s => s.split(separator)
